import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

// Firebase web yapılandırması (web config public'tir; gömülmesi güvenlidir).
export const firebaseConfig = {
  apiKey: 'AIzaSyAwsMKuByk4IJMwGSmVyZcP6YmVsQ8arBQ',
  authDomain: 'quotation-wizard-9195e.firebaseapp.com',
  projectId: 'quotation-wizard-9195e',
  storageBucket: 'quotation-wizard-9195e.firebasestorage.app',
  messagingSenderId: '838991695355',
  appId: '1:838991695355:web:0d33f202132e8febdd4f5e',
  measurementId: 'G-BH3QY821XC',
};

export const firebaseApp = initializeApp(firebaseConfig);
export const db = getFirestore(firebaseApp);
export const auth = getAuth(firebaseApp);
